import { Link } from '@remix-run/react'
import { type useOptionalUser } from '#app/utils/user.js'
import { Button } from './ui/button'

export function StaticHeader({
	user,
	position = 'absolute',
}: {
	user: ReturnType<typeof useOptionalUser>
	position: 'absolute' | 'relative'
}) {
	return (
		<header
			className={`${position} left-0 top-0 flex h-20 w-full items-center justify-between border-b border-b-border px-4 md:px-6`}
		>
			<nav className="flex w-full items-center justify-between gap-3">
				<Link to="/" className="ml-1 mr-3 block outline-offset-8 outline-ring">
					<img className="h-14 dark:hidden" src="/logo.png" alt="Kogia Logo" />
					<img
						className="hidden h-14 dark:block"
						src="/logo-dark.png"
						alt="Kogia Logo"
					/>
				</Link>
				<div className="flex items-center gap-4">
					<Button asChild variant={'ghost'} size="default">
						<Link
							className="!bg-transparent underline underline-offset-2 hover:!text-[#8B8B8B]"
							to="/"
						>
							Library
						</Link>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<a
							className="!bg-transparent hover:!text-[#8B8B8B]"
							href="https://www.kogia.org/projects"
						>
							Projects
						</a>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<a
							className="!bg-transparent hover:!text-[#8B8B8B]"
							href="https://www.kogia.org/fellowships"
						>
							Fellowships
						</a>
					</Button>
					<Button asChild variant={'ghost'} size="default">
						<a
							className="!bg-transparent hover:!text-[#8B8B8B]"
							href="https://www.kogia.org/about"
						>
							About
						</a>
					</Button>
					{/* <Button asChild variant={'ghost'} size="default">
						<Link to="/apply">Apply</Link>
					</Button> */}
					{/* {user && (
						<Button asChild variant={'ghost'} size="default">
							<Link to="/">Go to app</Link>
						</Button>
					)} */}
					{!user && (
						<>
							<Button asChild variant={'ghost'} size="lg">
								<Link to="/login">Login</Link>
							</Button>
							<Button asChild variant={'ghost'} size="lg">
								{/* TODO: Fix link */}
								<Link to="/signup">Sign Up</Link>
							</Button>
						</>
					)}
				</div>
			</nav>
		</header>
	)
}
